export default __webpack_public_path__ + "static/james-9dbbfd66ca09f6cd37a811afc038a3d0.jpg";